export enum Status {
  Pending = 'disabled',
  Success = 'primary',
  Error = 'error',
  Warning = 'warning'
}
